var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield-2--shield-protection-security-defend-crime-war-cover"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.05164 16.096L8.37735 16.3589C8.13419 16.4501 7.86623 16.4501 7.62307 16.3589L6.94878 16.096C5.24087 15.4264 3.77388 14.2586 2.73849 12.7442C1.7031 11.2299 1.14721 9.43907 1.14307 7.6046V4.42746C2.43734 4.61191 3.75741 4.44387 4.96421 3.94105C6.171 3.43822 7.21983 2.61921 8.00021 1.57031C9.42878 3.65031 11.7945 4.63317 14.8574 4.42746V7.6046C14.8532 9.43907 14.2973 11.2299 13.2619 12.7442C12.2265 14.2586 10.7595 15.4264 9.05164 16.096V16.096Z",
    stroke: "#949A9E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.b7921650c9aafd5d967cde78483866c8.svg";
export { ForwardRef as ReactComponent };